import { render, staticRenderFns } from "./QuoteImage.vue?vue&type=template&id=4b5d57e2&"
import script from "./QuoteImage.vue?vue&type=script&lang=js&"
export * from "./QuoteImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports